module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving6-eae91259dc4a608fff3b87461ce2b822.jpg";